
import {AllRoutes} from '../src/Routes/AllRoutes'

function App() {
  return (
    <div className="App">
      <AllRoutes/>
    </div>
  );
}

export default App;